<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            (click)="closeModal()"
            class="btn-close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="content-img">
              <img src="assets/image/success-icon.svg" alt="" />
            </div>

            <p class="txt-success-generate">
              Ordem avaliada com sucesso.
            </p>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>
